<template>
	<div class="drip-campaign-item-summary">
		<section
			class="summary-item"
			v-for="item in items"
			:key="item.dripCampaignItemId"
		>
			<div class="summary-text">
				<h2>{{ item.title }}</h2>
				<p>{{ item.description }}</p>
			</div>
			<div class="summary-preview">
				<img :src="item.thumbNailUri" :alt="item.title" />
				<button
					class="b360-btn b360-btn--secondary"
					@click="setPreviewItem(item)"
				>
					Preview {{ item.type.itemTypeDesc }}
				</button>
			</div>
		</section>

		<BaseModal
			v-if="previewItem"
			:modalTitle="`Preview ${previewItem.type.itemTypeDesc}`"
			@close="previewItem = null"
			:showFooter="false"
		>
			<div slot="modalBody">
				<img class="selected-preview" :src="previewItem.previewUri" />
			</div>
		</BaseModal>
	</div>
</template>

<script>
import BaseModal from '@/components/global/BaseModal.vue';

export default {
	name: 'DripCampaignItemSummary',
	components: { BaseModal },
	props: {
		items: null,
	},
	data() {
		return {
			previewItem: null,
		};
	},
	methods: {
		setPreviewItem(item) {
			this.previewItem = item;
		},
	},
};
</script>

<style lang="scss" scoped>
.drip-campaign-item-summary {
	@include rem('padding', 30px 0);

	.summary-item {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		flex-direction: column;
		max-width: 900px;
		@include rem('margin-bottom', 30px);

		@include larger-than-mobile {
			flex-direction: row;
		}

		.summary-preview {
			display: flex;
			flex-direction: column;
			@include rem('margin-right', 30px);
			order: 2;

			@include larger-than-mobile {
				order: 1;
			}

			img {
				width: 200px;
				@include rem('margin-bottom', 10px);
				border-radius: $border-radius;
			}

			button {
				width: 200px;
				border-width: $border-width;
				border-style: none;
			}
		}
	}
	.summary-text {
		order: 1;

		@include larger-than-mobile {
			order: 2;
		}

		h2 {
			@include rem('margin-top', 6px);
		}
	}
}

.selected-preview {
	width: 100%;
	@include rem('margin-bottom', -4px);
	border-bottom-right-radius: $b360-border-radius-base;
	border-bottom-left-radius: $b360-border-radius-base;
}

/* Remove modal double scrollbar */
/deep/ .modal {
	overflow-y: hidden;
}
</style>
